import './AccountRegistration.scss';

import { orderBy } from 'lodash';
import React, { Fragment } from 'react';

import { isCollegeSavings } from 'services/Products';
import { get529RegistrationForm } from 'services/Externals';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import AccountLabel from 'components/shared/AccountLabel/AccountLabel';

const Owners = ({ owners }) => (
  <div className="account-registration-owners">({owners && owners})</div>
);

const RegistrationLine = ({ registrationLine }) => (
  <div className="account-registration-registration-line">
    {registrationLine}
  </div>
);

const AccountNumber = ({ accountNumber, accountChecksum }) => (
  <span>
    {accountNumber}-{accountChecksum}
  </span>
);

const OwnersWithPermissions = WithUserPermissions(Owners);
const RegistrationLineWithPermissions = WithUserPermissions(RegistrationLine);
const AccountNumberWithPermissions = WithUserPermissions(AccountNumber);

const AccountRegistrationTable = ({ registration }) => {
  const firstAgreement = registration && registration.length && registration[0];
  const is529Account = isCollegeSavings(
    firstAgreement && firstAgreement.productType
  );
  const sortedAgreements = orderBy(registration, ['accountName']);
  const hasRegistrationLines =
    (firstAgreement &&
      firstAgreement.accountRegistration &&
      firstAgreement.accountRegistration.length) ||
    (firstAgreement.registrationAddress &&
      firstAgreement.registrationAddress.length);

  return (
    <Fragment>
      <div className="account-registration-account-type-container">
        <div className="account-registration-account-type">
          {firstAgreement && firstAgreement.accountType}
          <OwnersWithPermissions owners={firstAgreement.owners} shouldMask />
        </div>
        {is529Account && (
          <div className="account-registration-college-savings">
            <a
              rel="noreferrer"
              href={get529RegistrationForm(
                firstAgreement && firstAgreement.productType
              )}
              target="_blank">
              Update Account Registration
            </a>
          </div>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th>Account Name</th>
            <th>Account Number</th>
          </tr>
        </thead>
        <tbody>
          {sortedAgreements.map((account, i) => {
            const {
              accountName,
              accountType,
              accountNumber,
              accountChecksum,
              accountId
            } = account;
            return (
              <tr key={i} className="account-registration-account-table-label">
                <td className="account-registration-account-info">
                  {accountName} - {accountType}
                  <AccountLabel accountId={accountId}/>
                </td>
                <td className="account-registration-account-info">
                  <AccountNumberWithPermissions
                    accountNumber={accountNumber}
                    accountChecksum={accountChecksum}
                    shouldMask
                  />
                </td>
              </tr>
            );
          })}
          {hasRegistrationLines && (
            <tr>
              <td>
                The following account registration applies to the above
                account(s):
                <div className="account-registration-registration-lines">
                  {firstAgreement &&
                    firstAgreement.accountRegistration &&
                    firstAgreement.accountRegistration.map(
                      (registrationLine, i) => {
                        return (
                          <RegistrationLineWithPermissions
                            key={i}
                            registrationLine={registrationLine}
                            shouldMask
                          />
                        );
                      }
                    )}
                  {firstAgreement &&
                    firstAgreement.registrationAddress &&
                    firstAgreement.registrationAddress.map(
                      (addressLine, idx) => {
                        return (
                          <RegistrationLineWithPermissions
                            key={idx}
                            registrationLine={addressLine}
                            shouldMask
                          />
                        );
                      }
                    )}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Fragment>
  );
};

export default AccountRegistrationTable;
